import {
  InstantAnswerBuilderFn,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import {
  MessageRetailerOrBrandButton,
  additionalDataRequiredForContactingRetailerOrBrandCTA,
} from "../../shared/instantAnswerUtils";

export const Customs: InstantAnswerBuilderFn = (strictLocalize) => ({
  titleBuilder: () => customsBuilder(strictLocalize).getTitle(),
  descriptionBuilder: () => customsBuilder(strictLocalize).getDescription(),
  primaryCtaBuilder: {
    textBuilder: (context) => {
      return MessageRetailerOrBrandButton(context, strictLocalize)?.label;
    },
    onClickFunctionBuilder: (context) => {
      return MessageRetailerOrBrandButton(context, strictLocalize)?.onClick;
    },
  },

  additionalRequiredData:
    additionalDataRequiredForContactingRetailerOrBrandCTA(),
});

const customsBuilder = (
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () =>
      strictLocalize({
        defaultMessage: "Contact the retailer about customs clearance",
        description: {
          text: "Title for the answer of contact the retailer about customs issue",
        },
      }),
    getDescription: () => [
      strictLocalize({
        defaultMessage:
          "If you need information from the retailer to ensure that the shipment clears customs, you can message the retailer directly. If you have any other issues, please contact us.",
      }),
    ],
  };
};
